import React, { useState } from "react";
import { Button } from "../../../design/button";
import {
  Alert,
  AlertActions,
  AlertDescription,
  AlertTitle,
} from "../../../design/alert";
import { useDocument } from "../../../contexts/DocumentContext";

interface Props {
  documentId: string;
  content: string;
}

const PublishDocumentButton: React.FC<Props> = ({ documentId, content }) => {
  const { updateDocument } = useDocument();
  const [isOpen, setIsOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const handleSubmit = async () => {
    setIsSaving(true);
    try {
      await updateDocument(documentId, {
        content,
      });
      setIsOpen(false);
    } catch (error) {
      console.error("Error publishing document:", error);
      alert("Failed to publish document. Please try again later.");
    }
    setIsSaving(false);
  };

  return (
    <>
      <Button type="button" color="green" onClick={() => setIsOpen(true)}>
        Save
      </Button>
      <Alert open={isOpen} onClose={setIsOpen}>
        <AlertTitle>Publish Changes?</AlertTitle>
        <AlertDescription>
          Are you sure you want to publish these changes?
        </AlertDescription>
        <AlertActions>
          <Button plain onClick={() => setIsOpen(false)} disabled={isSaving}>
            Cancel
          </Button>
          <Button color="green" onClick={handleSubmit} disabled={isSaving}>
            Save
          </Button>
        </AlertActions>
      </Alert>
    </>
  );
};

export default PublishDocumentButton;
